import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { Nillable } from '@web/utils';
import { AdminMultimediaGridDefaultTemplateColumns } from '../../consts/admin-multimedia-grid-default-template-columns';

@Component({
  selector: 'app-multimedia-grid-layout',
  templateUrl: './multimedia-grid-layout.component.html',
  styleUrl: './multimedia-grid-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class MultimediaGridLayoutComponent {
  /* prettier-ignore */
  public readonly templateColumns = input<Nillable<string>>(AdminMultimediaGridDefaultTemplateColumns);
}
